module.exports = new Promise((resolve) => {
              const env = window?.localStorage?.getItem('ecommerce_env');
              const remote_url = env === 'development'
                ? 'https://development.business.app.veo.co/remoteEntry.js'
                : 'https://business.app.veo.co/v0/remoteEntry.js';
              const script = document.createElement('script');
              script.src = remote_url;
              script.onload = () => {
                const proxy = {
                  get: (request) => window.ecommerce.get(request),
                  init: (arg) => {
                    try {
                      return window.ecommerce.init(arg);
                    } catch(e) {
                      console.log('remote container already initialized.', e);
                    }
                  }
                }
                resolve(proxy)
              };
              document.head.appendChild(script);
            });